module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic8.95e94e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic8.png
// module id = 487
// module chunks = 1